<template>
  <AtomAnchor
    class="article-card"
    :style="style"
    :to="article.to"
  >
    <UiComponentImage
      :alt="article.name"
      class="logo"
      contains
      :expected-size="32"
      :height="article.logo.height"
      orientation="portrait"
      :source="article.logo.url"
      theme="dark"
      :width="article.logo.width"
    />
    <UiComponentHeading
      :level="3"
      theme="dark"
    >
      {{ article.title }}
    </UiComponentHeading>
    <AtomButton
      theme="dark"
      type="text"
    >
      {{ article.callToAction }} <UiComponentIcon
        theme="dark"
        type="arrow-right"
      />
    </AtomButton>
  </AtomAnchor>
</template>

<script setup>
// Props
const props = defineProps({
  article: {
    required: true,
    type: Object,
  },
})

// Computed Properties
const style = computed(() => {
  return {
    background: props.article.backgroundColor,
  }
})
</script>

<style lang="postcss" scoped>
.article-card {
  @apply flex flex-col items-start justify-end w-full h-85 p-6 rounded-4xl bg-livestorm-blue-500 transform transition-transform ease-out duration-500;

  @screen md {
    @apply px-8 h-122;
  }

  &:hover {
    transform: scale(1.02);
  }

  .logo {
    @apply h-8 rounded-none;
  }

  h3 {
    @apply mt-6 text-white;
  }

  .button {
    @apply px-0 mt-6 text-white !important;

    &:hover {
      @apply text-white;
    }

    i {
      @apply text-origin text-white ml-1;
    }
  }
}
</style>
